/**
 * The cache writes that keep the reads in this folder current. Actions call
 * these after a write; there is only one record to keep, so there is only one.
 */
import { QueryClient } from '@tanstack/react-query';
import { GetMeResponseData } from '@/api';
import { FETCH_ME_QUERY_KEY } from './me-query-keys';

export function addOrUpdateMeCache(
    queryClient: QueryClient,
    data: GetMeResponseData
): void {
    queryClient.setQueryData<GetMeResponseData>(
        [FETCH_ME_QUERY_KEY],
        () => data
    );
}
